<template>
     <div class="category_component">
         <ul class="columns is-mobile is-multiline">
             <li class="column is-paddingless column_post is-one-fifth-desktop is-half-mobile" v-for="category in categories" :key="category.id">
                 <router-link :to="{name:'category', params:{ id: category.params}}">
                 <div class="card">
                    <header class="card-header">
                        <p class="card-header-title">
                        {{category.title}}
                        </p>
                    </header>
                    <div class="card-content" style="font-weight:bold;">
                        {{category.description}}
                    </div>
                 </div>
                 </router-link>
             </li>
         </ul>
    </div>
</template>

<script>
export default {
    data(){
        return{
            categories:[
                {title:"人物",params:"人物",description:"登場人物など"},
                {title:"人体",params:"人体",description:"体の部位・感覚など"},
                {title:"職業",params:"職業",description:"職業・役割など"},
                {title:"動物",params:"動物",description:"動物など"},
                {title:"植物",params:"植物",description:"木・花など"},
                {title:"生物",params:"生物",description:"動物以外"},
                {title:"場所",params:"場所",description:"場所に関係する"},
                {title:"建物",params:"建物",description:"ビルなど建築物"},
                {title:"乗り物",params:"乗り物",description:"乗り物と関係する物"},
                {title:"生活",params:"生活",description:"生活周辺の物"},
                {title:"道具",params:"道具",description:"道具全般"},
                {title:"衣服",params:"衣服",description:"衣服、アクセサリー"},
                {title:"スポーツ",params:"スポーツ",description:"スポーツ全般"},
                {title:"楽器",params:"楽器",description:"楽器に関する物"},
                {title:"趣味",params:"趣味",description:"趣味全般"},
                {title:"自然",params:"自然",description:"自然全般"},
                {title:"現象",params:"現象",description:"現象全般"},
                {title:"空想",params:"空想",description:"空想上の存在"},
                {title:"食べ物",params:"食べ物",description:"食べ物全般"},
                {title:"飲み物",params:"飲み物",description:"飲み物全般"},
                {title:"行事",params:"行事",description:"イベント全般"},
                {title:"感情",params:"感情",description:"感情全般（怖いなど）"},
                {title:"行動",params:"行動",description:"行動全般（走るなど）"},
            ]
        }
    }
}
</script>

<style scoped>
.card{
    margin: 4px;
}
.card:hover {
    transform: scale(1.03);
    transition-duration: 0.3s;
}
.card-header-title{
    font-size: 1em
}
.card-content{
    padding:12px;
}
</style>